import Component from '@bythepixel/component-loader';

export default class publishOn extends Component {
  static selector = '[comp-publish-on]'

  constructor(...args) {
    super(...args);
    this.DOMEvent = this.$container.getAttribute('comp-publish-on');
    this.eventName = this.$container.getAttribute('publish-event');
    this.$container.addEventListener(this.DOMEvent, e => this.$publish(this.eventName, this.$container.dataset, e));
  }
}
